import React from 'react';
import LetterpressImage from 'assets/images/filters/letterpress.jpg';
import ProvisionalFilterModal from 'cards/components/CardListing/CardListingRedesign/ProvisionalComponents/ProvisionalFilterModal';

const FilterLetterpressModal = ({ hideModalFn }) => (
  <ProvisionalFilterModal
    title="What's Letterpress?"
    hideModalFn={hideModalFn}
    imageSrc={LetterpressImage}
    imageDesc="letterpress"
    description="This premium printing method uses raised, inked surfaces to press designs onto paper and create crisp impressions. The result? A luxurious, elegant look and feel that’s ideal for more formal wedding styles."
    btnText="Got It"
  />
);

export default FilterLetterpressModal;
